import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { Icon } from '@paysense-india-services/elevate-web'

import CardList from '@/components/CardList'

import ACTION_TYPES from '../../utils/actionTypes'

import styles from './index.module.scss'

const KEYBOARD_ACTIVATION_KEYS = ['Enter', ' ']

const mapApiItemsToCardList = apiItems => {
  if (!Array.isArray(apiItems)) {
    return []
  }
  return apiItems.map((item, index) => ({
    id: item.id ?? `profile-${index}`,
    title: item.title ?? '',
    actions: item.actions ?? {},
    assets: item.assets ?? {},
    showArrow: item.showArrow ?? true
  }))
}

const ProfileList = ({ data, noCard = false, onItemClick }) => {
  const navigate = useNavigate()
  const apiItems = data?.components?.items

  const mappedItems = useMemo(() => mapApiItemsToCardList(apiItems), [apiItems])

  const handleItemClick = item => {
    if (onItemClick) {
      const handled = onItemClick(item)
      if (handled === true) return
    }

    const defaultAction = item?.actions?.default
    if (!defaultAction?.url) return

    const actionType = defaultAction.type ?? defaultAction.actions

    if (actionType === ACTION_TYPES.WEBLINK) {
      window.open(defaultAction.url, '_blank', 'noopener,noreferrer')
    } else if (item.route) {
      navigate(item.route)
    } else {
      navigate(defaultAction.url)
    }
  }

  const handleKeyDown = (event, item) => {
    if (KEYBOARD_ACTIVATION_KEYS.includes(event.key)) {
      event.preventDefault()
      handleItemClick(item)
    }
  }

  const renderItem = item => (
    <div
      className='ew-d-flex ew-align-items-center ew-cursor-pointer ew-gap-16'
      onClick={() => handleItemClick(item)}
      onKeyDown={event => handleKeyDown(event, item)}
      role='button'
      tabIndex={0}>
      {item.assets?.leadingIcon ? (
        <div
          className={`${styles.iconContainer} ew-d-flex ew-align-items-center ew-justify-content-center ew-border ew-rounded-md ew-p-8`}>
          <img alt={item.title ?? 'Icon'} height={24} src={item.assets.leadingIcon} width={24} />
        </div>
      ) : null}

      <div className='ew-typography-small ew-fw-regular ew-flex-grow-1 ew-color-primary'>
        {item.title}
      </div>

      {item.assets?.trailingIcon || item.showArrow ? (
        <div
          className={`ew-d-flex ew-align-items-center ew-justify-content-center ew-bg-secondary ${styles.arrowContainer}`}>
          <Icon fill='#171717' name='rightArrowHead' size={14} />
        </div>
      ) : null}
    </div>
  )

  return <CardList items={mappedItems} noCard={noCard} renderItem={renderItem} />
}

export default ProfileList
